import { FC, useEffect, useState } from 'react';
import { TbArrowRight, TbPuzzle } from 'react-icons/tb';
import { Link, useNavigate } from 'react-router-dom';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

import { SmallTooltip } from '../../tooltips';
import SmallTag from '../SmallTag';

interface RequiredAddOnSmallTagProps {
    i: any;
    includeColon?: boolean;
    type?: 'Data Source' | 'Resource';
}

const RequiredAddOnSmallTag: FC<RequiredAddOnSmallTagProps> = ({
    i,
    includeColon = true,
    type = 'Data Source',
}): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { token } = useAntDesignTheme();

    const navigate = useNavigate();

    return (
        <SmallTooltip
            title={
                <>
                    This {type} requires a feature-add that isn't currently active in your workspace. You can add &
                    manage your Feature Add-Ons at{' '}
                    <Link to='/settings/account/plans/addons'>
                        Setting
                        <TbArrowRight style={{ verticalAlign: '-0.1rem', margin: '0 0.125rem' }} />
                        Account
                        <TbArrowRight style={{ verticalAlign: '-0.1rem', margin: '0 0.125rem' }} />
                        Plans & Billing
                        <TbArrowRight style={{ verticalAlign: '-0.1rem', margin: '0 0.125rem' }} />
                        Add-Ons
                    </Link>
                </>
            }
            placement='topLeft'
            padding='1rem 0'
        >
            <span onClick={() => navigate(`/settings/account/plans/addons`)}>
                <SmallTag
                    message={
                        <span style={{ fontWeight: 400 }}>
                            <TbPuzzle
                                style={{ verticalAlign: '-1px', marginRight: '0.125rem' }}
                                fill={token.cyan3}
                                stroke={token.cyan6}
                            />
                            Requires
                            {i?.requiredAddOnsForUse?.length > 1 ? 's' : undefined}
                            {includeColon ? ':' : ''}{' '}
                            {i?.requiredAddOnsForUse?.map((fao: any) => {
                                return <strong>{fao}</strong>;
                            })}
                        </span>
                    }
                    styles={{
                        backgroundColor: token.cyan1,
                        // border: `1px solid ${token.cyan3}`,
                        color: token.cyan6,
                        marginLeft: 0,
                        cursor: 'pointer',
                    }}
                />
            </span>
        </SmallTooltip>
    );
};

export default RequiredAddOnSmallTag;
